/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateCurrentUser, updateIsLoggedIn } from 'store/user';
import {
  Layout,
  // Breadcrumb,
  Dropdown,
  Space,
  // Avatar,
  Typography,
  message,
  Button,
  Popover
} from 'antd';

// import EbzButton from 'components/EbzButton';
import Alert from 'components/Alert';
import User from 'services/authentication';
import { EbzStripIcon, LogoutIcon, DropDownIcon } from 'utils/icons';
import merchantAPI from 'services/merchants';
import { QuestionCircleFilled } from '@ant-design/icons';
import handleCommonRediection from 'components/CommonRedirect.js/CommonRediection';

const { Header } = Layout;

function NavHeader() {
  // const planModal = useSelector((state) => state.user.planModal);
  // const planType = useSelector((state) => state.user.plan.plan_type);
  const rmDetails = useSelector((state) => state.user.rmDetails);

  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const configs = useSelector((state) => state.user.currentUser.configuration);

  const showSalesforce = configs?.permission_configs?.can_login_salesforce;
  const showPartneKyc = configs?.permission_configs?.can_update_partner_kyc;
  const teamUserCheck = user?.currentUser?.user_id;

  // const togglePlanModal = () => {
  //   dispatch(updatePlanModal(!planModal));
  // };

  const userLogout = async () => {
    const response = await User.logout();
    if (!response.success) {
      Alert('something went wrong', 'Please contact support team for this', 'error');
    } else {
      dispatch(updateIsLoggedIn(true));
      dispatch(updateCurrentUser({}));
      handleCommonRediection(teamUserCheck);
    }
  };

  const kycVerify = async () => {
    message.info({
      content: 'Fetching Kyc verification link'
    });

    const response = await merchantAPI.partnerKycVerify();

    if (response.success) {
      window.open(response.data.redirection_url, '_blank');
      message.info({
        content: 'You are being redirected to link'
      });
    } else {
      console.log('something went wrong');
      Alert('something went wrong', response?.data?.error?.message, 'error');
    }
  };

  const redirectToSalesforce = async () => {
    message.info({
      content: 'Redirecting to Salesforce login...'
    });

    try {
      const url = 'https://easebuzzprivatelimited.my.site.com/services/auth/sso/Partners';
      window.open(url, '_blank');

      message.success({
        content: 'You are being redirected to Salesforce'
      });
    } catch (error) {
      console.error('Redirection failed', error);
      Alert('Something went wrong', 'Please contact the support team for this', 'error');
    }
    await merchantAPI.InitiateSalesForceSignIn();
  };

  const items = [
    ...(!teamUserCheck
      ? [
          {
            key: 1,
            label: (
              <div>
                <EbzStripIcon /> <a href={process.env.REACT_APP_DASHBOARD_URL}>Go To Easebuzz</a>
              </div>
            )
          }
        ]
      : []),
    ...(showPartneKyc
      ? [
          {
            key: 2,
            label: <div onClick={kycVerify}>Go To KYC</div>
          }
        ]
      : []),
    ...(showSalesforce
      ? [
          {
            key: 3,
            label: <div onClick={redirectToSalesforce}>Go To Salesforce</div>
          }
        ]
      : []),
    {
      key: 4,
      label: (
        <div onClick={userLogout}>
          <LogoutIcon /> Logout
        </div>
      )
    }
  ];

  const Rmcontent = (
    <span>
      <Typography.Text style={{ color: 'var(--color-primary)', fontSize: '16px' }}>
        RM Details
      </Typography.Text>
      <br />
      <Typography.Text style={{ color: '#817e7e' }}>Name : {rmDetails?.rm_name}</Typography.Text>
      <br />
      <Typography.Text style={{ color: '#817e7e' }}>
        Email ID :{' '}
        <Typography.Text style={{ color: '#817e7e' }} underline>
          {rmDetails?.rm_email}
        </Typography.Text>
      </Typography.Text>
    </span>
  );

  return (
    <Header
      style={{
        padding: 0,
        background: 'white'
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'end',
          alignItems: 'center',
          padding: '5px 15px'
        }}
      >
        {/* <Breadcrumb
          separator=">"
          style={{
            color: var(--color-primary),
            fontSize: '16px'
          }}
        >
          <Breadcrumb.Item>Referrals</Breadcrumb.Item>
        </Breadcrumb> */}

        {/* {planType === 'BASIC' && (
          <Space style={{ marginRight: '28px' }} size="small">
            <EbzButton size="large" onClick={togglePlanModal} style={{ color: var(--color-primary) }}>
              <CrownIcon />
              Upgrade Your Plan
            </EbzButton>
          </Space>
        )} */}

        <Space>
          {/* <Avatar
            style={{
              margin: '0 10px'
            }}
            size={40}
            icon={<AntDesignOutlined />}
          /> */}
          {rmDetails?.rm_name && rmDetails?.rm_email && (
            <Popover content={Rmcontent} trigger="hover" placement="leftTop">
              <Button
                shape="circle"
                icon={<QuestionCircleFilled style={{ fontSize: '24px' }} />}
                size="large"
                style={{
                  borderColor: 'transparent',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              />
            </Popover>
          )}
          <Dropdown
            menu={{
              items
            }}
            placement="bottomRight"
            trigger="click"
            style={{ width: '100px' }}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Typography.Text style={{ fontSize: '18px', fontWeight: '500' }}>
                {user?.currentUser?.name ?? ''}
              </Typography.Text>
              <DropDownIcon
                style={{ color: 'var(--color-primary)', fontSize: '14px', marginLeft: '10px' }}
              />
            </a>
          </Dropdown>
        </Space>
      </div>
    </Header>
  );
}

export default NavHeader;
